import { HttpResult } from "widgets-for-react";
import { KnowledgeArticlePageData } from "../../sharepointPageApi/types/pageData";
import { DossierArticles } from "./dossierArticlesBlockState";

export const dossierArticlesBlockApi = async (id: number): Promise<HttpResult<DossierArticles>> => {
    const res = await fetch(`/api/v1/pages/dossier-articles/${id}`);
  
    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }
  
    const data: KnowledgeArticlePageData[] = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data.map((article) => ({
        title: article.HeaderTitle,
        slug: article.AbsolutePath,
      })),
    };
  }